import React from 'react';
import ActiveLink from '../Header/ActiveLink/ActiveLink';
import styles from './breadcrumbs.module.scss';

export interface CrumbProps {
    url: string;
    name: string;
}

export interface BreadcrumbsProps {
    crumbs: CrumbProps[];
}

const BreadcrumbsComponent = ({ crumbs }: BreadcrumbsProps) => {
    return (
        <div className={styles.breadCrumbsContainer}>
            {crumbs.map((crumb, index) => (
                <span key={`key-${crumb.name}`}>
                    <span className={styles.crumb}>
                        {crumb.url !== '' && (
                            <ActiveLink
                                href={crumb.url}
                                className={`${index !== crumbs.length - 1 ? styles.minor : ''}`}
                                activeClassName="active"
                            >
                                <span>{crumb.name}</span>
                            </ActiveLink>
                        )}
                        {crumb.url === '' && (
                            <span
                                className={`${styles.unClickable} ${index !== crumbs.length - 1 ? styles.minor : ''}`}
                            >
                                {crumb.name}
                            </span>
                        )}
                    </span>
                    {index !== crumbs.length - 1 && <span className={styles.spacer}>\</span>}
                </span>
            ))}
        </div>
    );
};

export default BreadcrumbsComponent;
